import Stack from "@mui/material/Stack";
import {Box} from "@mui/material";
import {s_char_mr} from "../../_signals/s_char_calc";
import {Item} from "../CharStyled";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import {s_app_mobile} from "../../_signals/s_app";

export default function CharMR() {
    useSignals();
    return <Item>
        <Stack direction={'column'}>
            <label>Mystische Rüstung</label>
            <Box sx={{width: 1 / 2}}>{s_char_mr.value}</Box>
        </Stack>
    </Item>
}